import React from 'react';
import {Col, Row} from 'antd';
import {Cell, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';

const IncomePieChart = ({data}) => {
    const RADIAN = Math.PI / 180;

    const renderCustomizedLabel = ({cx, cy, midAngle, innerRadius, outerRadius, percent}) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="white"
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"
                fontSize="12"
                fontWeight="bold"
            >
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    const CustomTooltip = ({active, payload}) => {
        if (active && payload && payload.length) {
            return (
                <div style={{
                    backgroundColor: 'white',
                    padding: '10px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    <p style={{margin: 0, fontWeight: 'bold', color: '#262626'}}>{payload[0].name}</p>
                    <p style={{margin: '5px 0 0 0', fontSize: '14px'}}>
                        {payload[0].value.toLocaleString('ru-RU')} €
                    </p>
                    <p style={{margin: 0, fontSize: '12px', color: '#666'}}>
                        {payload[0].payload.percentage}% от общих доходов
                    </p>
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            <div style={{textAlign: 'center', marginBottom: '20px'}}>
                <h3 style={{margin: 0, color: '#262626', fontSize: '16px'}}>Структура доходов</h3>
            </div>

            <Row gutter={16}>
                <Col span={16}>
                    <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                label={renderCustomizedLabel}
                                outerRadius={80}
                                innerRadius={40}
                                fill="#8884d8"
                                dataKey="value"
                                stroke="#fff"
                                strokeWidth={2}
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color}/>
                                ))}
                            </Pie>
                            <Tooltip content={<CustomTooltip/>}/>
                        </PieChart>
                    </ResponsiveContainer>
                </Col>

                <Col span={8}>
                    <div style={{paddingTop: '30px'}}>
                        {data.map((item, index) => (
                            <div key={index} style={{marginBottom: '15px'}}>
                                <div style={{display: 'flex', alignItems: 'center', marginBottom: '5px'}}>
                                    <div style={{
                                        width: '12px',
                                        height: '12px',
                                        backgroundColor: item.color,
                                        borderRadius: '2px',
                                        marginRight: '8px'
                                    }}/>
                                    <span style={{fontWeight: 'bold', fontSize: '14px', color: '#262626'}}>
                                        {item.name}
                                    </span>
                                </div>
                                <div style={{paddingLeft: '20px'}}>
                                    <div style={{fontSize: '15px', color: '#262626'}}>
                                        {item.value.toLocaleString('ru-RU')} €
                                    </div>
                                    <div style={{fontSize: '13px', color: '#666'}}>
                                        {item.percentage}% от общей суммы
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default IncomePieChart;